import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { Workbook } from "exceljs";
import * as fs from "file-saver";
import { IExcelOrExportDataObject } from "../models/excelOrExportDataObject.model";
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: "root"
})
export class ExcelService {
  fileName: string;
  sheetName: string;
  title: string;
  headerColumns: Array<string>;
  data: Array<any>;
  header: IExcelOrExportDataObject[] = [];
  private headerStyle: any;



  constructor(private datePipe: DatePipe, private utilityService: UtilityService) {
    this.headerStyle = {
      font: { bold: true }
    };
  }

 


  // generateCSVFile()
  // {
  //   
  // let fname=  `${
  //     this.fileName !== ""
  //       ? this.fileName.replace(" ", "_")
  //       : "Health Slice"
  //   }.csv`;
  //   const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
  //   const header = Object.values(this.headerColumns);
  //   const header1 = Object.keys(this.headerColumns);

  //   let csv = this.data.map(row => header1.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
  //   csv.unshift(header.join(','));
  //   let csvArray = csv.join('\r\n');
  //   let blob = new Blob([csvArray], {type: 'text/csv' })
  //   saveAs(blob, fname);
  // }

  generateAsCSV(includeHeader: boolean) {
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(
      this.sheetName ? this.sheetName : "Sheet1"
    );




    if (includeHeader == true) {
      //Add Header Row

      let headerRow = worksheet.addRow(this.headerColumns);
      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "0f6bc1" },
        };
        cell.font = {
          bold: true,
          name: "verndana",
          size: 10,
          color: { argb: "FFFFFF" }
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };
      });
    }
    this.data.forEach(d => {
      let row = worksheet.addRow(d);
      row.font = {
        name: "verndana",
        size: 10
      };

    });

    workbook.csv.writeBuffer().then(data => {
      const BOM = "\uFEFF";
      let blob = new Blob([BOM + data], {
        type: "text/csv;charset=utf-8"
      });
      fs.saveAs(
        blob,
        `${this.fileName !== ""
          ? this.fileName.replace(/[ ]/gi, "_")
          : "Health_Slice"
        }.csv`
      );
    });
  }
  generateExcel() {
    
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(
      this.sheetName ? this.sheetName : "Sheet1"
    );

    // Add new row
    let titleRow = worksheet.addRow([this.title]);

    // Set font, size and style in title row.
    titleRow.font = {
      name: "verdana",
      family: 3,
      size: 12,
      underline: "single",
      bold: true
    };

    // Blank Row
    worksheet.addRow([]);
    //Add row with current date
    let subTitleRow = worksheet.addRow([
       "Date : " + this.datePipe.transform(new Date(), "medium")
    ]);

    subTitleRow.font = {
      bold: true
    };

    //Add Header Row
    let headerRow = worksheet.addRow(this.headerColumns);
    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "0f6bc1" },
      };
      cell.font = {
        bold: true,
        name: "verndana",
        size: 10,
        color: { argb: "FFFFFF" }
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
      cell.alignment = { //vertical: 'middle', horizontal: 'center', 
        wrapText: true
      };

    });

    //each column width
    worksheet.columns.forEach(function (column, i) {
      (i !== 0) ? (column.width = 15) : (column.width = 20);
    });

    // Add Data and Conditional Formatting
    this.data.forEach(d => {
      let row = worksheet.addRow(d);
      row.font = {
        name: "verndana",
        size: 10
      };
      // let qty = row.getCell(5);
      // let color = 'FF99FF99';
      // if (+qty.value < 500) {
      //     color = 'FF9999'
      // }
      // qty.fill = {
      //     type: 'pattern',
      //     pattern: 'solid',
      //     fgColor: { argb: color }
      // }
      row.alignment = {
        //vertical: 'middle', horizontal: 'center',
        wrapText: true
      };
    });


    workbook.xlsx.writeBuffer().then(data => {
      let blob = new Blob([data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      fs.saveAs(
        blob,
        `${this.fileName !== ""
          ? this.fileName.replace(/[ ]/gi, "_")
          : "Health Slice"
        }.xlsx`
      );
    });
  }

  generateCSV() {
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(
      this.sheetName ? this.sheetName : "Sheet1"
    );
    // Add new row
    let titleRow = worksheet.addRow([this.title]);
    // Set font, size and style in title row.
    titleRow.font = {
      name: "verdana",
      family: 3,
      size: 12,
      underline: "single",
      bold: true
    };

    // Blank Row
    worksheet.addRow([]);
    //Add row with current date
    let subTitleRow = worksheet.addRow([
       "Date : " + this.datePipe.transform(new Date(), "medium")
    ]);

    subTitleRow.font = {
      bold: true
    };

    //Add Header Row
    let headerRow = worksheet.addRow(this.headerColumns);
    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "0f6bc1" },
      };
      cell.font = {
        bold: true,
        name: "verndana",
        size: 10,
        color: { argb: "FFFFFF" }
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
    //
    //  let row=worksheet.getRow(4);
    //  row.font={
    //   bold: true,
    //   name: "verndana", 
    //   size: 10, 
    //   color: { argb: "FFFFFF"} 
    //  };
    // Add Data and Conditional Formatting
    this.data.forEach(d => {
      let row = worksheet.addRow(d);
      row.font = {
        name: "verndana",
        size: 10
      };
      row.alignment = {
        //vertical: 'middle', horizontal: 'center',
        wrapText: true
      };
    });

    workbook.csv.writeBuffer().then(data => {
      const BOM = "\uFEFF";

      let blob = new Blob([BOM + data], {
        type: "text/csv;charset=utf-8"
        //"application/vnd.ms-excel"
        // "application/octet-stream" 
        // 'text/plain;charset=utf-8'
        // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      fs.saveAs(
        blob,
        `${this.fileName !== ""
          ? this.fileName.replace(/[ ]/gi, "_")
          : "Health Slice"
        }.csv`
      );
    });
  }


  //New methods which works for matrix type as well along with all other question types
  private numToAlpha(num: number) {
    //
    let alpha = '';
    for (; num >= 0; num = parseInt((num / 26).toString(), 10) - 1) {
      alpha = String.fromCharCode(num % 26 + 0x41) + alpha;
    }
    return alpha;
  }
  generateExcelNew() {
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(
      this.sheetName ? this.sheetName : "Sheet1"
    );

    // Add new row
    let titleRow = worksheet.addRow([this.title]);

    // Set font, size and style in title row.
    titleRow.font = {
      name: "verdana",
      family: 3,
      size: 12,
      underline: "single",
      bold: true
    };

    // Blank Row
    worksheet.addRow([]);
    //Add row with current date

    //Add row with current date - using local browser timezone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let subTitleRow = worksheet.addRow([
      "Date : " + this.utilityService.getTimestampByTimeZoneAndLocale('en-US', userTimeZone)
    ]);

    subTitleRow.font = {
      bold: true
    };


    //Add Header Row for  questions
    let parentheader: Array<string> = [];
    this.header.forEach(x => {
      parentheader.push(x.headerText);
      if (x.subheaders.length > 0) {
        for (let i = 1; i < x.subheaders.length; i++) {
          parentheader.push('');
        }
      }

    });
    let headerRow = worksheet.addRow(parentheader);

    //Merge Cells for Parent ques
    let i = 0;
    this.header.forEach(x => {
      let alphaStart = this.numToAlpha(i);
      if (x.subheaders.length > 1) {
        let alphaEnd = this.numToAlpha(i + (x.subheaders.length - 1));
        worksheet.mergeCells(alphaStart + '4:' + alphaEnd + '4');
        i = i + (x.subheaders.length - 1);
      }
      i++;
    })

    //add sub header for sub questions

    let subheader: Array<string> = [];

    this.header.forEach(x => {
      if (x.subheaders.length == 0) {
        subheader.push('');
      }
      else {
        x.subheaders.forEach(y => {
          subheader.push(y);
        })
      }

    })

    let sub = worksheet.addRow(subheader);
    //Sub questions Cell Style : Fill and Border
    sub.eachCell((cell, number) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "4c9be6" },
      };
      cell.font = {
        bold: true,
        name: "verndana",
        size: 10,
        color: { argb: "FFFFFF" }
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "0f6bc1" },
      };
      cell.font = {
        bold: true,
        name: "verndana",
        size: 10,
        color: { argb: "FFFFFF" }
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };

    });

    // Add Data and Conditional Formatting
    this.data.forEach(d => {
      let row = worksheet.addRow(d);
      row.font = {
        name: "verndana",
        size: 10
      };
      // let qty = row.getCell(5);
      // let color = 'FF99FF99';
      // if (+qty.value < 500) {
      //     color = 'FF9999'
      // }
      // qty.fill = {
      //     type: 'pattern',
      //     pattern: 'solid',
      //     fgColor: { argb: color }
      // }
    });


    workbook.xlsx.writeBuffer().then(data => {
      let blob = new Blob([data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      fs.saveAs(
        blob,
        `${this.fileName !== ""
          ? this.fileName.replace(/[ ]/gi, "_")
          : "Health Slice"
        }.xlsx`
      );
    });

  }

  /**
   * Generates Excel workbook as a Blob without downloading locally.
   * Uses the same formatting as generateExcelNew but returns a Promise<Blob>.
   */
  generateExcelNewAsBlob(): Promise<Blob> {
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(
      this.sheetName ? this.sheetName : "Sheet1"
    );

    let titleRow = worksheet.addRow([this.title]);
    titleRow.font = {
      name: "verdana",
      family: 3,
      size: 12,
      underline: "single",
      bold: true
    };

    worksheet.addRow([]);

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let subTitleRow = worksheet.addRow([
      "Date : " + this.utilityService.getTimestampByTimeZoneAndLocale('en-US', userTimeZone)
    ]);
    subTitleRow.font = { bold: true };

    // Add Header Row for questions
    let parentheader: Array<string> = [];
    this.header.forEach(x => {
      parentheader.push(x.headerText);
      if (x.subheaders.length > 0) {
        for (let i = 1; i < x.subheaders.length; i++) {
          parentheader.push('');
        }
      }
    });
    let headerRow = worksheet.addRow(parentheader);

    // Merge Cells for Parent ques
    let i = 0;
    this.header.forEach(x => {
      let alphaStart = this.numToAlpha(i);
      if (x.subheaders.length > 1) {
        let alphaEnd = this.numToAlpha(i + (x.subheaders.length - 1));
        worksheet.mergeCells(alphaStart + '4:' + alphaEnd + '4');
        i = i + (x.subheaders.length - 1);
      }
      i++;
    });

    // Add sub header for sub questions
    let subheader: Array<string> = [];
    this.header.forEach(x => {
      if (x.subheaders.length == 0) {
        subheader.push('');
      } else {
        x.subheaders.forEach(y => {
          subheader.push(y);
        });
      }
    });

    let sub = worksheet.addRow(subheader);
    sub.eachCell((cell, number) => {
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4c9be6" } };
      cell.font = { bold: true, name: "verndana", size: 10, color: { argb: "FFFFFF" } };
      cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
    });

    headerRow.eachCell((cell, number) => {
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "0f6bc1" } };
      cell.font = { bold: true, name: "verndana", size: 10, color: { argb: "FFFFFF" } };
      cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
    });

    this.data.forEach(d => {
      let row = worksheet.addRow(d);
      row.font = { name: "verndana", size: 10 };
    });

    return workbook.xlsx.writeBuffer().then(data => {
      return new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
    });
  }

  generateCSV_New() {
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(
      this.sheetName ? this.sheetName : "Sheet1"
    );
    // Add new row
    let titleRow = worksheet.addRow([this.title]);
    // Set font, size and style in title row.
    titleRow.font = {
      name: "verdana",
      family: 3,
      size: 12,
      underline: "single",
      bold: true
    };
    // Blank Row
    worksheet.addRow([]);

    //Add row with current date
    let subTitleRow = worksheet.addRow([
      "Date : " + this.datePipe.transform(new Date(), "medium")
    ]);
    subTitleRow.font = {
      bold: true
    };


    //Add Header Row for  questions
    let header_appendedWithSubQues: Array<string> = [];
    this.header.forEach(x => {
      if (x.subheaders.length > 0) {
        x.subheaders.forEach(y => {
          header_appendedWithSubQues.push(x.headerText + ' (Sub Question : ' + y + ' )');
        })
      }
      else {
        header_appendedWithSubQues.push(x.headerText);
      }
    });

    let headerRow = worksheet.addRow(header_appendedWithSubQues);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "0f6bc1" },
      };
      cell.font = {
        bold: true,
        name: "verndana",
        size: 10,
        color: { argb: "FFFFFF" }
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });

    // Add Data and Conditional Formatting
    this.data.forEach(d => {
      let row = worksheet.addRow(d);
      row.font = {
        name: "verndana",
        size: 10
      };

    });

    workbook.csv.writeBuffer().then(data => {
      const BOM = "\uFEFF";

      let blob = new Blob([BOM + data], {
        type: "text/csv;charset=utf-8"
        //"application/vnd.ms-excel"
        // "application/octet-stream"
        // 'text/plain;charset=utf-8'
        // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      fs.saveAs(blob,
        `${this.fileName !== ""
          ? this.fileName.replace(/[ ]/gi, "_")
          : "Health Slice"
        }.csv`
      );
    });
  }
  generateAsCSV_New(includeHeader: boolean) {
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(
      this.sheetName ? this.sheetName : "Sheet1"
    );


    if (includeHeader == true) {
      //Add Header Row for  questions
      let header_appendedWithSubQues: Array<string> = [];
      this.header.forEach(x => {
        if (x.subheaders.length > 0) {
          x.subheaders.forEach(y => {
            header_appendedWithSubQues.push(x.headerText + ' (Sub Question : ' + y + ' )');
          })
        }
        else {
          header_appendedWithSubQues.push(x.headerText);
        }
      });

      let headerRow = worksheet.addRow(header_appendedWithSubQues);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "0f6bc1" },
        };
        cell.font = {
          bold: true,
          name: "verndana",
          size: 10,
          color: { argb: "FFFFFF" }
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };
      });
    }
    this.data.forEach(d => {
      let row = worksheet.addRow(d);
      row.font = {
        name: "verndana",
        size: 10
      };
    });

    workbook.csv.writeBuffer().then(data => {
      const BOM = "\uFEFF";
      let blob = new Blob([BOM + data], {
        type: "text/csv;charset=utf-8"
      });
      fs.saveAs(
        blob,
        `${this.fileName !== ""
          ? this.fileName.replace(/[ ]/gi, "_")
          : "Health_Slice"
        }.csv`
      );
    });
  }
  createWorkBook(): ExcelJS.Workbook {
    const workbook = new ExcelJS.Workbook();
    return workbook;
  }

  AddSheet(workbook: ExcelJS.Workbook, sheetname: string): ExcelJS.Worksheet {
    const sheet = workbook.addWorksheet(sheetname);
    return sheet;
  }

  addDataToSheet(sheet: ExcelJS.Worksheet, data: any[], headers: string[] = []): void {
    if (!data || !data.length) {
      return;
    }

    // Add headers if provided
    if (headers.length) {
      const headerRow = sheet.addRow(headers);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    }

    // Add data rows
    data.forEach((rowData: any) => {
      const values = headers.length ? headers.map(header => rowData[header]) : rowData;
      const row = sheet.addRow(values);

      // Apply borders to each cell in the row
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });
  }
  applyRowColor(sheet: ExcelJS.Worksheet, rowIndex: number, headerLength: number, color: string): void {
    const row = sheet.getRow(rowIndex);
    sheet.mergeCells(rowIndex, 1, rowIndex, headerLength);
    for (let i = 1; i <= headerLength; i++) {
      const cell = row.getCell(i);
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color.replace('#', 'FF') } // Ensure the color is in ARGB format
      };

      // Set the font to bold
      cell.font = {
        bold: true
      };
    }
  }

  setAutoWidth(sheet: ExcelJS.Worksheet, headerColumns) {
    headerColumns.forEach((header, index) => {
      const column = sheet.getColumn(index + 1);
      let maxLength = 0;

      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, cellValue.length);
      });

      column.width = maxLength + 2; // Adding some extra space for padding
    });
  } 

  saveWorkbook(workbook: ExcelJS.Workbook, filename: string): void {
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, filename);
    });
  }
  applyHeaderStyle(sheet: any, headerRow: string[]) {
    const row = sheet.addRow(headerRow);
    row.eachCell({ includeEmpty: true }, (cell: any) => {
      cell.font = this.headerStyle.font;
    });
  }


}

